module.exports = __webpack_public_path__ + "media/img/home/our-work/photo-3-hover-80dcedbd2778f53598b01cd326ee4983.webp";